import type { WizardData } from "@/pages/CreateCard";
import { useTranslation } from "react-i18next";

interface Props {
  data: WizardData;
  updateData: (u: Partial<WizardData>) => void;
}

const occasionValues = [
  "birthday", "farewell", "baby", "wedding", "thank-you", "retirement",
  "get-well", "sympathy", "graduation", "teacher", "anniversary",
  "christmas", "valentines", "congratulations",
];

const occasionKeyMap: Record<string, string> = {
  birthday: "birthday",
  farewell: "farewell",
  baby: "newBaby",
  wedding: "wedding",
  "thank-you": "thankYou",
  retirement: "retirement",
  "get-well": "getWell",
  sympathy: "sympathy",
  graduation: "graduation",
  teacher: "teacher",
  anniversary: "anniversary",
  christmas: "christmas",
  valentines: "valentines",
  congratulations: "congratulations",
};

const occasionEmojis: Record<string, string> = {
  birthday: "🎂",
  farewell: "👋",
  baby: "👶",
  wedding: "💍",
  "thank-you": "🙏",
  retirement: "🎉",
  "get-well": "💐",
  sympathy: "🕊️",
  graduation: "🎓",
  teacher: "📚",
  anniversary: "❤️",
  christmas: "🎄",
  valentines: "💝",
  congratulations: "🏆",
};

const StepOccasion = ({ data, updateData }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-foreground font-serif">
        {t("wizard.occasion.title")}
      </h2>
      <div className="grid grid-cols-2 gap-3">
        {occasionValues.map((val) => (
          <button
            key={val}
            onClick={() => updateData({ occasion: val })}
            className={`flex items-center gap-2.5 px-4 py-3.5 rounded-xl border text-sm font-medium transition-all text-start ${
              data.occasion === val
                ? "border-primary bg-primary/10 text-primary"
                : "border-border text-foreground hover:border-foreground/30"
            }`}
          >
            <span className="text-lg">{occasionEmojis[val]}</span>
            {t(`occasions.${occasionKeyMap[val]}`)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default StepOccasion;
